import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "../styles/TodoList.css";
import {
  AiOutlineUndo,
  AiOutlinePushpin,
  AiOutlineDelete,
  AiOutlineEdit,
  AiOutlineSave,
} from "react-icons/ai";

function TodoItem({ todo, updateTodo, deleteTodo, showActions, isDarkMode }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedTask, setEditedTask] = useState(todo.task);

  const handleSave = () => {
    if (editedTask.trim()) {
      updateTodo(todo.id, { task: editedTask.trim() });
      setIsEditing(false);
    } else {
      alert("Task cannot be empty!");
    }
  };

  return (
    <li
      className={classNames(
        "list-group-item d-flex justify-content-between align-items-center",
        {
          "bg-warning": todo.pinned,
          "text-decoration-line-through": todo.completed,
          "light-mode": !isDarkMode,
          "dark-mode": isDarkMode,
        }
      )}
    >
      {isEditing ? (
        <input
          type="text"
          value={editedTask}
          onChange={(e) => setEditedTask(e.target.value)}
          className="form-control me-2"
        /> 
      ) : (
        <span className="todo-task">{todo.task}</span>
      )}
      {showActions && (
        <div>
          {isEditing ? (
            <>
              <button
                className="btn btn-success btn-sm me-2"
                onClick={handleSave}
              >
                <AiOutlineSave /> Lưu
              </button>
              <button
                className="btn btn-secondary btn-sm"
                onClick={() => setIsEditing(false)}
              >
                Ok
              </button>
            </>
          ) : (
            <>
              <button
                className="btn btn-primary btn-sm me-2"
                onClick={() =>
                  updateTodo(todo.id, { completed: !todo.completed })
                }
              >
                <AiOutlineUndo /> {todo.completed ? "Chưa xong" : "Hoàn Thành"}
              </button>
              <button
                className="btn btn-warning btn-sm me-2"
                onClick={() => updateTodo(todo.id, { pinned: !todo.pinned })}
              >
                <AiOutlinePushpin /> {todo.pinned ? "Hủy Ghim" : "Ghim"}
              </button>
              <button
                className="btn btn-danger btn-sm me-2"
                onClick={() => deleteTodo(todo.id)}
              >
                <AiOutlineDelete /> Xóa
              </button>
              <button
                className="btn btn-info btn-sm"
                onClick={() => setIsEditing(true)}
              >
                <AiOutlineEdit /> Sửa
              </button>
            </>
          )}
        </div>
      )}
    </li>
  );
}

TodoItem.propTypes = {
  todo: PropTypes.shape({
    id: PropTypes.number.isRequired,
    task: PropTypes.string.isRequired,
    completed: PropTypes.bool.isRequired,
    pinned: PropTypes.bool.isRequired,
  }).isRequired,
  updateTodo: PropTypes.func.isRequired,
  deleteTodo: PropTypes.func.isRequired,
  showActions: PropTypes.bool.isRequired,
  isDarkMode: PropTypes.bool.isRequired,
};

export default TodoItem;
